import 'whatwg-fetch';
import { api } from 'config';
import LoginService from 'services/Login';

const getNotifications = () => {
    const token = LoginService.getUserToken();

    if(!token) return Promise.resolve(false);

    return fetch(api.headerNotifications + `/notifications`, {
        method: 'GET',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json'
        }
    }).then(data => data.json());
}

const deleteNotifications = () => {
    const token = LoginService.getUserToken();

    return fetch(api.headerNotifications + `/notifications`, {
        method: 'DELETE',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json'
        }
    }).then(data => data.json());
}

const readNotifications = () => {
    const token = LoginService.getUserToken();

    return fetch(api.headerNotifications + `/notifications/read`, {
        method: 'POST',
        headers: {
            'x-api-key': api.apiKey,
            'token': token,
            'Content-Type': 'application/json'
        }
    }).then(data => data.json());
}


const HeaderNotifications = {
    getNotifications,
    deleteNotifications,
    readNotifications
}

export default HeaderNotifications;
